export default __webpack_public_path__ + "images/file-icon.svg";